{
  "intercom": {
    "events": [
      "Cancel Order Failed",
      "Change Order Address Completed",
      "Cancel Order Completed",
      "User Login Failed",
      "Gift Card Tapped",
      "Checkout Sheet Opened",
      "Checkout Tapped",
      "Image Access Failed",
      "Add Credit Card Failed",
      "Address Validation Failed",
      "Photos Permission Denied",
      "Notification Opened",
      "Apple Pay Tapped",
      "Invalid Promo Code Attempted",
      "Promo Code Removed",
      "Remove Promo Code Tapped",
      "Promo Code Added",
      "Add Promo Code Tapped",
      "Low Resolution Warning Displayed",
      "Attribution Survey Answered",
      "Order Completed",
      "Order Confirmed",
      "Complete Order Tapped",
      "Shipping Address Added",
      "Tile Cropped",
      "Tile Preview Tapped",
      "Credit Card Added",
      "Add Address Tapped",
      "Photo Picked",
      "Photos Permission Granted",
      "First Open",
      "[Art] First Open",
      "Homepage Main CTA Tapped",
      "Web Email Captured",
      "Art Email Captured",
      "Gift Card Order Completed",
      "First Interaction",
      "Quiz Finished Succesfully",
      "[Art] Product Viewed",
      "Checkout - Payment Method Added",
      "Checkout - Shipping Address Added",
      "Talk To Us Tapped"
    ],
    "userProperties": [
      "user_id",
      "name",
      "email",
      "Browser",
      "Minimum Order of Tiles Experiment",
      "Wall Decoration Enabled",
      "Multiple Sizes Enabled",
      "City",
      "Email",
      "Language",
      "Country",
      "Pricing Variant",
      "Used Promo Code",
      "Name",
      "Email",
      "User ID",
      "Web sessions",
      "Country",
      "Browser Language",
      "Browser",
      "Browser Version",
      "OS",
      "iOS App version",
      "iOS OS version",
      "Android App version",
      "Android OS version",
      "Has Apple Pay",
      "Platform",
      "Unified UID"
    ]
  }
}
